import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@/components';

import styles from './TraceStepsBanner.module.sass';

const TraceStepsBanner = (): JSX.Element => {
  const { t } = useTranslation();

  const steps = [
    t('translation.ai_investigation_step_paste'),
    t('translation.ai_investigation_step_trace'),
    t('translation.ai_investigation_step_result'),
  ];

  return (
    <div className={styles.banner}>
      <span className={styles.title}>
        {t('translation.ai_investigation_steps_title')}
      </span>

      <div className={styles.steps}>
        {steps.map((step, index) => (
          <div className={styles.step} key={step}>
            <span className={styles.badge}>{index + 1}</span>
            <span className={styles.label}>{step}</span>
            {index < steps.length - 1 && (
              <SvgIcon name="arrow-right" className={styles.connector} />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TraceStepsBanner;
